// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28PMq","top":"styles_top__3YKnR","left":"styles_left__2JCcL","description":"styles_description__M6nrJ"};